import React, {useContext, useEffect, useRef, useState} from "react";
import {Badge, Button, Card, Col, ListGroup, Row} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import {accountContext} from "../../App";
import AuthCheck from "../../components/AuthCheck";
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleArrowLeft} from "@fortawesome/free-solid-svg-icons";
// import ViewerComponent from "../../components/Viewer/ViewerComponent";
import HistogramComponent from "../../components/Histogram/HistogramComponent";
import ViewerV2 from "../../components/ViewerV2/components/Viewer";


export default function StudentSubmissionReview() {

    let { studentnumber,submission } = useParams();
    useContext(accountContext);
    const viewerRef = useRef(null);

    const [rules,setRules] = useState({});
    const [ruleResult,setRuleResults] = useState({});
    const [caseID,setCaseID] = useState(null);


    useEffect(()=>{
        loadRules()
            .then(rulesByOrgan => {
                setRules(rulesByOrgan);
                console.log(rulesByOrgan);
                loadSubmission().then(submissionResp => {
                    if(submissionResp){
                        setCaseID(submissionResp.caseID)
                        let resultObj = {};
                        for (const ruleResult of submissionResp.ruleResults) {

                            resultObj[ruleResult.parentRuleId] = ruleResult;
                        }
                        setRuleResults(resultObj);
                        console.log(resultObj);
                    }

                })
            })
            .catch(err => {
                console.error(err)
            });
        // eslint-disable-next-line
    }, []);

    function loadSubmission() {
        return new Promise((resolve, reject) => {
            axios.get("/api/student/submission/"+submission,{
                withCredentials: false} )
                .then(response => {
                    if(response.data){
                        resolve(response.data);
                    }else{
                        reject("No data in 'rulesFromSubmission'");
                    }

                })
                .catch(err => {
                    reject(err)
                });
        });
    }

    function loadRules() {
        return new Promise((resolve, reject) => {
            axios.get("/api/case/rulesFromSubmission/"+submission,{
                withCredentials: false} )
                .then(response => {
                    if(response.data){
                        let rulesByOrgan = {};
                        for (const rules of response.data) {
                            if(Array.isArray(rulesByOrgan[rules.organ])){
                                rulesByOrgan[rules.organ].push(rules);
                            }else{
                                rulesByOrgan[rules.organ] = [rules];
                            }
                        }
                        resolve(rulesByOrgan);
                    }else{
                        reject("No data in 'rulesFromSubmission'");
                    }

                })
                .catch(err => {
                    reject(err)
                });
        });
    }

    function stringifyRule(rule) {
        if(rule.ruleType === "struct2GSrules"){
            return  <p>Distance to golden standard is for <b>{rule.percentage}</b>% within <b>{rule.threshold}</b> mm.</p>
        }else if(rule.ruleType === "dist2OtherRules"){
            return  <p>Distance overlaps for <b>{rule.percentage}</b>% with <b>{rule.threshold}</b> mm over <b>{rule.otherOrgan}</b>.</p>
        }else if(rule.ruleType === "lengthRules"){
            return  <p>Length difference exceeds golden standard with <b>{rule.threshold}</b> slices.</p>
        }else if(rule.ruleType === "volumeRules"){
            return  <p>Volume difference exceeds golden standard with <b>{rule.percentage}</b>%.</p>
        }
    }




    return(
        <>
            <AuthCheck/>
            <Row style={{position:"relative",width:"100%",  paddingTop: "20px",height: "calc(100% - 20px)"}}>
                <Col xs={{span: 12}} md={{span: 6}} lg={{span: 6}} className="mb-3 h-100">

                    <Card className="h-100">
                        <Card.Body style={{overflowY:"scroll"}}>
                            <h4><Link to={"/student/"+studentnumber}><Button size="sm" variant="secondary"><FontAwesomeIcon icon={faCircleArrowLeft} /> Back</Button></Link></h4>
                            {Object.entries(rules).map(([key,list]) =>
                                <Card key={key}>
                                    <Card.Header>{key}</Card.Header>
                                    <Card.Body>
                                        <ListGroup >
                                            {list.map((object) =>
                                                <ListGroup.Item
                                                    key={"object_"+object.id}
                                                    action
                                                    className="d-flex justify-content-between align-items-start"
                                                >
                                                    <div className="ms-2 me-auto">
                                                        <div>{stringifyRule(object)}</div>
                                                        Your result is: <b>{ruleResult[object.id] && ruleResult[object.id].result}</b>
                                                    </div>
                                                    <Badge bg={ruleResult[object.id] && ruleResult[object.id].passed  ? "success" : "danger"} pill>
                                                        {ruleResult[object.id] &&                                                               // make sure ruleResult is loaded
                                                        ruleResult[object.id].passed === (object.ruleType==="struct2GSrules") ?                  //Check if passed and reverse for additive rule struct2Grules
                                                            (object.ruleType==="struct2GSrules" ? '+'+object.grading : '-'+object.grading) :    //Respond with proper +/- and grading
                                                            "0"                                                                                 //Or respond with 0 if rule did not affect score
                                                        } /{object.ruleType==="struct2GSrules" ? '+' : '-'}{object.grading}
                                                    </Badge>
                                                </ListGroup.Item>)}
                                        </ListGroup>
                                    </Card.Body>
                                </Card>
                            )}

                        </Card.Body>
                    </Card>
                </Col>
                <Col  xs={{span: 12}} md={{span: 6}} lg={{span: 6}} className="mb-3">
                    <Card >
                        <Card.Body >
                            { caseID ?
                                <div>
                                    <div style={{height: "600px"}}>
                                        <ViewerV2 ref={viewerRef} case={caseID} />
                                        {/*<ViewerComponent*/}
                                        {/*    case={caseID}*/}
                                        {/*    session={2}*/}
                                        {/*    showGS={true}*/}
                                        {/*    showST={studentnumber}//or a studentnumber*/}
                                        {/*/>*/}
                                    </div>
                                    <div className="mt-3">
                                        <HistogramComponent showST={studentnumber}  case={caseID}/>
                                    </div>
                                </div>
                            :false}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>


        </>
    )
}
